import React, { useEffect, useRef, useContext } from 'react'
import { Marker } from 'maplibre-gl/dist/maplibre-gl'
import MapContext from './MapContext'
import { useMapPin } from '../../slices/map'

const PinControl = (props) => {

  const map = useContext(MapContext)
  const marker = useRef()
  const pin = useMapPin()

  useEffect(() => {
    if (!map) return

    if (pin) {
      if (!marker.current) {
        marker.current = new Marker({ color: '#499BC8' })
        marker.current.setLngLat(pin).addTo(map)
      } else {
        marker.current.setLngLat(pin)
      }
    } else {
      if (marker.current) {
        marker.current.remove()
        marker.current = null
      }
    }

    return () => {
      if (marker.current) {
          marker.current.remove()
          marker.current = null
      }
    }

  }, [map, pin])
  
  return null
}

export default PinControl
